module.exports = __webpack_public_path__ + "img/plus-img.110a8f77.svg";